import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'wdx-info-card',
    templateUrl: './wdx-info-card.component.html',
    styleUrls: ['./wdx-info-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
    host: {
        '[class.card]': 'hostCardClass',
        '[class.flush]': 'flushClass',
    },
})
export class WdxInfoCardComponent {
    @Input() bodyClasses!: string;
    @Input() set flush(flush: boolean) {
        this.flushClass = flush;
    }
    hostCardClass = true;
    flushClass = false;
}
